// currenty only used to ... Please delete this note if it gets extended beyond this use.

export const IMAGE_CONSTS = {
  UPLOAD_FILES: 'UPLOAD_FILES',
};
